import { useEffect } from 'react';

import { useMapContext } from 'shared/context/MapContext';

export function useAttachBallonManager(balloonManager: YMaps.BalloonManager): void {
  const { map } = useMapContext();

  useEffect(() => {
    map.geoObjects.add(balloonManager.objectManager);

    return (): void => {
      map.geoObjects.remove(balloonManager.objectManager);
    };
  }, [map.geoObjects, balloonManager.objectManager]);
}
